import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import {
  query,
  collection,
  orderBy,
  getDocs,
  or,
  and,
  where,
  Timestamp,
  addDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import "./index.css";

function StudentsAttendanceComponent() {
  const [studentList, setStudentList] = useState([]);
  const [calendardate, setCalendarDate] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [loading, setLoading] = useState(false)
  const [previousAttendance, setPreviousAttendance] = useState(null);
  const today = moment(new Date()).format(Dateformat.DDMMYYYY);

  // MARK: Use Effect Method
  useEffect(() => {
    setCalendarDate(new Date());
    fetchDefaultBatch()
    }, []);

  // MARK: date click function
  const clickOnDate = (e) => {
    const newDate = moment(e.value).format(Dateformat.YYYYMMDD);
    setCalendarDate(e.value);

    if (selectedBatch?.firebase_id) {
      previousAttendanceData(newDate, selectedBatch?.firebase_id);
    }
  };

  // MARK: attendance input

  const clickOnCheckBox = (selectedStudent) => () => {
    setStudentList((prevList) =>
      prevList.map((student) =>
        student.id === selectedStudent.id
          ? { ...student, isChecked: !student.isChecked }
          : student
      )
    );
  };

  // MARK: batch assign input
  const batchSelect = (e) => {
    setSelectedBatch(e);

    if (e === null) {
      return;
    }
    previousAttendanceData(calendardate, e.firebase_id);
  };

  const fetchDefaultBatch = async () => {
    let q = query(collection(dbFirestore, TableName.batches), where("batch_name", "==", "morning"));
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const morningBatch = {
          ...querySnapshot.docs[0].data(),
          firebase_id: querySnapshot.docs[0].id,
        };
  
        setSelectedBatch(morningBatch);
  
        // Fetch students and previous attendance for morning batch
        previousAttendanceData(moment(new Date()).format(Dateformat.YYYYMMDD), morningBatch.firebase_id);
      }
  };

  
  // MARK: fetch teacher attendance API
  async function previousAttendanceData(currentDate, batch_id) {
    let q = query(
      collection(dbFirestore, TableName.attendance),
      where(
        "date_value",
        "==",
        moment(currentDate).format(Dateformat.YYYYMMDD)
      ),
      where("batch_id", "==", batch_id)
    );

    const querySnapshot = await getDocs(q);
    const attendanceObject = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    if (attendanceObject.length > 0) {
      const attendanceIDs = attendanceObject[0]["attendance"];
      setPreviousAttendance(attendanceObject[0]);
      fetchStudentsApi(batch_id, attendanceIDs);
    } else {
      fetchStudentsApi(batch_id, []);
      setPreviousAttendance(null);
    }
  }

  // MARK: fetch students API

  async function fetchStudentsApi(batch_id, StudentIDs) {
    setStudentList([]); 
    
    let q = query(
      collection(dbFirestore, TableName.students),where("status", "==", "active"),
      orderBy("created_at", "desc"),
      where("batch_firebase_id", "==", batch_id)
    );
    const querySnapshot = await getDocs(q);

  
    const studentList = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));
  
    const newStudents = studentList.map((element) => {
      if (StudentIDs.includes(element.id)) {
        element["isChecked"] = true;
      }
      return element;
    });
  
    setStudentList(newStudents);  // Update state
  }

  // MARK: save function

  const tapOnSave = async () => {
    if (!selectedBatch) {
      toast.error(ToastMessages.batch);
      return;
    }

    const hasSelectedStudents = studentList.some(student => student.isChecked);

    if (!hasSelectedStudents) {
      toast.error("Please mark at least one student present.");
      return;
    }

    setLoading(true);
    try {
      if (previousAttendance) {
        await updateAttendance();  // Ensure this is awaited
      } else {
        await createAttendance();  // Ensure this is awaited
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    } 
  };

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      batch_id: selectedBatch.firebase_id,
      date_value: moment(calendardate).format(Dateformat.YYYYMMDD),
      created_at: createdAt,
    };

    var studentIDs = [];
               
    studentList.forEach((element) => {
      if (element.isChecked) {
        studentIDs.push(element.id);
      }
    });

    const dateOnly = Timestamp.fromDate(new Date(object.date_value)).toMillis();
    object.date = dateOnly;

    object.attendance = studentIDs;

    return object;
  }

  // MARK: write attendance API
  async function createAttendance() {
    const writePayload = payload();
    writePayload.batch_id = selectedBatch.firebase_id;
  
    try {
      await addDoc(collection(dbFirestore, TableName.attendance), writePayload);
      toast.success(ToastMessages.attendance);
      setTimeout(() => {
        setLoading(false);
      }, 2000);

      await previousAttendanceData(calendardate, selectedBatch.firebase_id);
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    } 
  }

   // MARK: update attendance API
  async function updateAttendance() {
    const writePayload = payload();
    writePayload.batch_id = selectedBatch.firebase_id;
  
    try {
      await updateDoc(
        doc(dbFirestore, TableName.attendance, previousAttendance.id),
        writePayload
      );
      toast.success(ToastMessages.attendanceUpdate);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      
      await previousAttendanceData(calendardate, selectedBatch.firebase_id);
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    } 
  }


  // MARK: batch list fetch from the firebase
  const batchList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.batches),
      or(
        // query as-is:
        and(
          where("batch_name", ">=", searchName),
          where("batch_name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "batch_name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "batch_name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);

    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));
    return array;
  };

  // MARK: batch name which show in the dropdown
  function batchName(e) {
    return e["batch_name"];
  }

  return (
    <div className="col-12">
      <div className="card modules__card mt-5 mb-2">

        <div className="p-fluid">
          <div className="row modules__row">
            <div className="row" style={{ alignItems: "self-end" }}>
              <div className="col-10">
                <h2 className="pt-3">Mark attendance of {today}</h2>
              </div>
              <div className="col-2">
                <Button
                  label="Save" loading={loading}
                  className="modules__save_button mt-3 float-end"
                  onClick={tapOnSave}
                  style={{ width: "5rem" }}
                ></Button>
              </div>
            </div>
            <ToastContainer autoClose={1000}/>
            <div className="col-12 col-md-6">
              <Calendar
                name="date_value"
                value={calendardate}
                onChange={clickOnDate}
                showIcon
                showButtonBar
                placeholder="dd/mm/yyyy"
                dateFormat="dd/mm/yy"
              />
            </div>
            <div className="col-12 col-md-6">
              <AsyncSelect className="table__column__capital"
                maxMenuHeight={170}
                isClearable
                cacheOptions
                loadOptions={batchList}
                value={selectedBatch}
                defaultOptions
                getOptionLabel={(e) => batchName(e)}
                getOptionValue={(e) => e}
                onChange={batchSelect}
              />
            </div>
          </div>
        </div>

        <DataTable
          className="mt-5 mb-3"
          value={studentList}
          emptyMessage="No data found."
        >
          <Column
            field="name"
            header="Name"
            frozen
            className="font-bold table__column__capital"
          ></Column>
          <Column field="admission_no" header="Admission Number"></Column>
          <Column
            field="actions"
            header="Select"
            body={(data) => (
              <>
                <input
                  type="checkbox"
                  className="checkbox_input"
                  onChange={clickOnCheckBox(data)}
                  checked={data?.isChecked}
                />
              </>
            )}
          ></Column>
        </DataTable>
      </div>
    </div>

  );
}

export default StudentsAttendanceComponent;
